import React from 'react'

import "./certificates.css";
import hthml from  "./html.jpg"

import css from  "./css.jpg"

import javascript from  "./javascript.jpg"


import programmi from  "./programmi.jpg"

import java from  "./java.jpg"


import google from  "./google.jpg"

import hack from  "./hack.jpeg"
import Typewriter from "typewriter-effect";

export default function certificates() {
	return (
		<>
		



<h1 className="text-center font-bold h2h">

<Typewriter
  

options={{
    delay: 75,
    autoStart: true,
    
  }}


       onInit={(typewriter)=> {

       typewriter
        
       .typeString("Check out my certifications.")
         

  


       .start();
       }}
       /> 


</h1>


<div className=" cer">
	

<div className="er text-center" >
	<img src={hthml} className="ceimg  " />


<p className="text-center pt">HTML</p>

</div>
<div  className="er text-center">
	<img src={css} className="ceimg"/>
<p className="text-center pt">CSS</p>
</div>

<div  className="er text-center">
	<img src={javascript}  className="ceimg"/>
<p className="text-center pt">JAVASCRIPT</p>
</div>
</div>


<div className=" cer1 ">
	

<div className="er text-center" >
	<img src={programmi} className="ceimg" />
<p className="text-center pt">Programming Foundations</p>
</div>

<div  className="er  text-center">
	<img src={java}  className="ceimg"/>
<p className="text-center pt">JAVA</p>
</div>

<div  className="er  text-center">
	<img src={google} className="ceimg" />
	<p className="text-center pt">GOOGLE</p>

</div>

<div  className="er text-center">
	<img src={hack}  className="ceimghack"/>
	<p className="text-center pt">Hackathon Participation</p>


</div>


</div>


		</>
	)
}